import { api } from "./client.js";

export interface DiscoverHit {
  id: string;
  name: string;
  handle: string | null;
  status: string;
}

export const discoveryApi = {
  search: (q: string) =>
    api.get<{ results: DiscoverHit[] }>(`/api/discovery/search?q=${encodeURIComponent(q)}`),
};
